import React, { Fragment, useState, useEffect } from 'react';
import "moment/locale/es";
import { Col, CardBody, Card, Row, Button } from 'reactstrap';
import ListPatientsPendingInvoiceTable from './ListPatientsPendingInvoiceTable';
import Spinner from 'react-bootstrap/Spinner';
import ListPatientsPendingInvoiceTableActions from './ListPatientsPendingInvoiceTableActions';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

const ListPatientsPendingInvoice = ({ }) => {

  const [loading, setLoading] = useState(false);
  const [filterState, setFilterState] = useState(1);
  const [dataPatients, setDataPatients] = useState([]);

  useEffect(() => {
    getPatientsPendingInvoice(filterState);
  }, []);

  const getPatientsPendingInvoice = async (stateFilter) => {
    setLoading(true);
    await fetch(process.env.REACT_APP_PUBLIC_URL + `admision/pacientes-pendientes-facturar?estado_facturacion=${stateFilter}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    }).then(response => {
      if (response.status != 500 && response.status != 403) {
        return response.json();
      }
      else {
        throw new Error("Ha ocurrido un error en el Servidor");
      }
    }).then(data => {
      setLoading(false);
      setDataPatients(data);
    }).catch((error) => {
      console.error(error);
      setLoading(false);
      setDataPatients([]);
    });
  }

  const ListDataPatientsPending = () => {
    return (<ListPatientsPendingInvoiceTable
      reactTableData={dataPatients}
      ReactTableActions={ListPatientsPendingInvoiceTableActions}
    />);
  }

  return (
    <Card>
      <CardBody>
        <Row>
          <Col md={6}>
            <TextField
              label="Filtro de Estado"
              required
              select
              value={filterState}
              onChange={(event) => {
                setFilterState(event.target.value);
                getPatientsPendingInvoice(event.target.value);
              }}
              className="medical-material-form__field"
            >
              <MenuItem key={1} value={1}>
                PENDIENTES
              </MenuItem>
              {/*<MenuItem key={2} value={2}>
              FACTURADAS
            </MenuItem>*/}
              <MenuItem key={3} value={3}>
                POR CORREGIR
              </MenuItem>
            </TextField>
          </Col>
        </Row>

        {
          loading == false ? <>
            {
              dataPatients.length > 0 ?
                <ListDataPatientsPending /> : null
            }
          </> :
            <div className='text-center'>
              <Spinner animation="border" variant="success" />
            </div>
        }
      </CardBody>
    </Card>
  );
}

export default ListPatientsPendingInvoice;